// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_benefit1_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Shock absorption reduces spinal compression with every step.`
};

const el_tech_benefit1_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Η απορρόφηση κραδασμών μειώνει τη συμπίεση της σπονδυλικής στήλης σε κάθε βήμα.`
};

const ru_tech_benefit1_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Амортизация снижает компрессию позвоночника при каждом шаге.`
};

const he_tech_benefit1_detail = /** @type {(inputs: {}) => string} */ () => {
	return `בליעת זעזועים מפחיתה לחץ על עמוד השדרה בכל צעד.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_benefit1_detail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_benefit1_detail(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_benefit1_detail", locale)
	if (locale === "en") return en_tech_benefit1_detail(inputs)
	if (locale === "el") return el_tech_benefit1_detail(inputs)
	if (locale === "ru") return ru_tech_benefit1_detail(inputs)
	if (locale === "he") return he_tech_benefit1_detail(inputs)
	return "tech_benefit1_detail"
};